import { Record, OrderedSet, Map, List } from 'immutable'
import { handleActions } from 'redux-actions'

import * as actions from './actions'
import { ProTrackLevel } from 'store/records/proTracks'
import listMove from 'helpers/immutable/listMove'

export const Levels = Record({
  all: Map(),
  view: null,
  ids: OrderedSet(),
  presenter: null,
  beforeCreateOrder: null,
  idToDelete: null,
  loaded: false,
})

const handleGetLevels = state => {
  return state.set('loaded', false)
}

const handleGetLevelsSuccess = (state, { payload }) => {
  let ids = OrderedSet()
  return state
    .set(
      'all',
      payload.data.reduce((acc, level) => {
        ids = ids.add(level.id)
        const ratesCount = level.rates && level.rates.filter(item => item.rate || item.comment).length
        return acc.set(level.id.toString(), new ProTrackLevel({ ...level, ratesCount }))
      }, Map())
    )
    .set('ids', ids)
    .set('loaded', true)
}

const handleCreateLevelSuccess = (state, { payload: { data } }) => {
  const levelsList = List(state.get('ids').map(id => state.getIn(['all', id.toString()])))
  const updatedLevels = levelsList.insert(data.order - 1, new ProTrackLevel(data)).reduce((acc, level, index) => {
    const reorderedLevel = level.toJS()
    reorderedLevel.order = index + 1
    return acc.set(level.get('id').toString(), new ProTrackLevel(reorderedLevel))
  }, Map())
  return state.set('ids', state.get('ids').add(data.id)).set('all', updatedLevels)
}

const handleUpdateLevelSuccess = (state, { payload: { data } }) => {
  return state.setIn(['all', data.id.toString()], new ProTrackLevel(data))
}

const handleSetOrder = (state, { payload }) => {
  const { list, oldIndex, newIndex } = payload
  const newList = listMove(list, oldIndex, newIndex).map((level, index) => level.set('order', index + 1))
  return state.set('all', newList.reduce((acc, el) => acc.set(el.get('id').toString(), el), Map()))
}

const handleSetDeleted = (state, { payload }) => {
  return state.setIn(['all', payload.id.toString(), 'deleting'], payload.isDeleting)
}

const handleSetBeforeCreateOrder = (state, { payload }) => {
  return state.set('beforeCreateOrder', payload.order)
}

const handlePublishLevelSuccess = state => {
  const levelId = state.get('view')
  const currentLevel = state.getIn(['all', levelId])
  return state.setIn(['all', levelId], new ProTrackLevel({ ...currentLevel.toJS(), active: true }))
}

export default handleActions(
  {
    [actions.getLevels]: handleGetLevels,
    [actions.getLevels.success]: handleGetLevelsSuccess,
    [actions.setOrder]: handleSetOrder,
    [actions.setDeleted]: handleSetDeleted,
    [actions.setBeforeCreateOrder]: handleSetBeforeCreateOrder,
    [actions.createLevel.success]: handleCreateLevelSuccess,
    [actions.updateLevel.success]: handleUpdateLevelSuccess,
    [actions.publishLevel.success]: handlePublishLevelSuccess,
  },
  new Levels()
)
